import { FormFieldsGeneratorService } from './../../customer-form/form-helpers/form-fields-generator.service';
import { Component, Input } from '@angular/core';
import { OrderDetailsSlotAddonComponent } from '../order-details/order-details-slot-addon.component';
import ManageTvService from '../manage-tv/manage-tv.service';
import { AddonTypeEnum } from '../../models/cartDetails/addonType.enum';
import { CommonAddonsService } from '../order-addons/common-addons.service';
import { FormFieldsMasks } from '../../customer-form/field-mask/form-fields-masks';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'new-offer-slot-addon',
  templateUrl: './new-offer-slot-addon.component.html',
})
export class NewOfferSlotAddonComponent extends OrderDetailsSlotAddonComponent {
  @Input() private bundleNumber: number;
  @Input() set addonData(addon: any) {
    this.addon = addon;
    this.updateData();
  }

  public showTv = false;
  public validationMasks = new FormFieldsMasks();
  public slotOfferForm: FormGroup;

  constructor(
    private commonAddonsService: CommonAddonsService,
    public manageTv: ManageTvService,
    private formsGenerator: FormFieldsGeneratorService
  ) {
    super();

    if (this.manageTv.isEditMode) {
      this.formsGenerator.setFirstStepActiveForm();
      this.slotOfferForm = this.formsGenerator.activeForm;
    }
  }

  public removeAddon(event: Event): void {
    event.preventDefault();

    this.commonAddonsService.removeAddon(this.addon.addonCode, this.bundleNumber, this.ordinalNumber);
  }

  public showRemoveLink(): boolean {
    return this.addon.addonGroup === 'optional' || this.addon.addonGroup === 'grouped';
  }

  private updateData(): void {
    this.showTv = this.addon.addonType === AddonTypeEnum.TV
      && this.commonInfo.isSolo
      && this.addon._computedFields.isDataOffer;
  }

  public submitNumber(event: Event): void {
    if (!this.slotOfferForm.valid) {
      this.formsGenerator.checkActiveFormValidation(this.slotOfferForm);
    }

    this.manageTv.submit(event);
  }

  protected onEditMode(event: Event): void {
    this.formsGenerator.setFirstStepActiveForm();
    this.slotOfferForm = this.formsGenerator.activeForm;
    this.manageTv.onEditMode(event);
  }
}
